import React from "react";
import mark from "@/assets/hayat-mark.png";

/**
 * Official HAYAT logo: circular H-monogram mark (gold) + editorial wordmark
 * HAYAT | حياة with "Women's Health" line. Text tone adapts (ink on light,
 * ivory on dark backgrounds).
 */
export const Logo = ({ className = "", tone = "ink", showTagline = true }) => {
  const isIvory = tone === "ivory";
  const textColor = isIvory ? "text-warm-ivory" : "text-deep-ink";
  const taglineColor = isIvory ? "text-warm-ivory/55" : "text-deep-ink/45";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img src={mark} alt="HAYAT" className="h-11 w-auto" draggable="false" />
      <span className="flex flex-col leading-none">
        <span className="flex items-center gap-2">
          <span className={`font-serif text-[1.6rem] font-medium tracking-[0.16em] ${textColor}`}>
            HAYAT
          </span>
          <span className="text-champagne-gold/40" aria-hidden="true">|</span>
          <span className="font-arabic text-lg text-champagne-gold" dir="rtl">حياة</span>
        </span>
        {showTagline && (
          <span className={`mt-1 text-[9px] uppercase tracking-[0.34em] ${taglineColor}`}>
            Women&apos;s Health
          </span>
        )}
      </span>
    </span>
  );
};
